import React from 'react';
import { Card, CardContent, Typography, Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

/**
 * Composant de carte pour le tableau de bord administrateur
 *
 * @param {Object} props - Les propriétés du composant
 * @param {React.ReactNode} props.icon - L'icône à afficher
 * @param {string} props.title - Le titre de la carte
 * @param {number|string} props.value - La valeur à afficher
 * @param {string} props.linkTo - L'URL de redirection
 * @param {string} props.color - La couleur principale de la carte
 * @param {string} props.buttonText - Le texte du bouton (par défaut: "Gérer")
 */
const DashboardCard = ({
                           icon,
                           title,
                           value,
                           linkTo,
                           color,
                           buttonText = "Gérer"
                       }) => {
    return (
        <motion.div
            whileHover={{
                y: -5,
                transition: { type: 'spring', stiffness: 300, damping: 20 }
            }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ type: 'spring', stiffness: 100, damping: 15 }}
        >
            <Card
                elevation={2}
                sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 2,
                    overflow: 'hidden',
                }}
            >
                <CardContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        flexGrow: 1,
                        p: 3,
                        pb: 2,
                        background: `linear-gradient(135deg, ${color}15 0%, rgba(255,255,255,0) 60%)`,
                    }}
                >
                    <Box
                        sx={{
                            p: 1.5,
                            borderRadius: '50%',
                            mb: 2,
                            backgroundColor: `${color}20`,
                            color: color,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {React.cloneElement(icon, { sx: { fontSize: 32 } })}
                    </Box>
                    <Typography
                        variant="h5"
                        component="div"
                        sx={{
                            fontWeight: 'bold',
                            mb: 0.5,
                            color: 'text.primary'
                        }}
                    >
                        {value}
                    </Typography>
                    <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{
                            mb: 1,
                            textAlign: 'center'
                        }}
                    >
                        {title}
                    </Typography>
                </CardContent>
                <Button
                    component={Link}
                    to={linkTo}
                    variant="contained"
                    sx={{
                        mt: 'auto',
                        py: 1,
                        backgroundColor: color,
                        '&:hover': {
                            backgroundColor: `${color}CC`,
                        },
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0,
                    }}
                >
                    {buttonText}
                </Button>
            </Card>
        </motion.div>
    );
};

export default DashboardCard;